import { render } from "./database.vue?vue&type=template&id=37f0286f&scoped=true&ts=true"
import script from "./database.vue?vue&type=script&lang=ts&setup=true"
export * from "./database.vue?vue&type=script&lang=ts&setup=true"

import "./database.vue?vue&type=style&index=0&id=37f0286f&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37f0286f"],['__file',"src/views/init/components/database.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37f0286f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37f0286f', __exports__)) {
    console.log('reload')
    api.reload('37f0286f', __exports__)
  }
  
  module.hot.accept("./database.vue?vue&type=template&id=37f0286f&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('37f0286f', render)
  })

}


export default __exports__